import React, { useState } from 'react';
import { TeamSection } from "@/components/sections/TeamSection";
import { HeroBanner } from "@/components/sections/HeroBanner";
import ImageTextSection from '@/components/sections/ImageTextSection';
import MisionVisionContentModal from '@/components/modals/MisionVisionContentModal';
import ListContentModal from '@/components/modals/ListContentModal';

// Textos para el modal de Misión y Visión
const visionText = `Escuela Especial de Lenguaje Arcoíris se consolidará como un
establecimiento reconocido en brindar una formación de futuros
ciudadanos como seres integrales, autónomos y con una formación
valórica basada en el respeto, compañerismo, responsabilidad,
empatía, solidaridad, tolerancia y perseverancia, permitiéndoles
generar participación y conciencia en sus aprendizajes, para que sean
capaces de resolver distintas problemáticas de su vida cotidiana, siendo
respetuosos de la individualidad de las personas, familia y de su entorno
biopsicosocial.`;

const misionText = `Garantizar experiencias educativas diversas que promuevan
ambientes de enseñanza- aprendizaje dinámicos, colaborativos e
inclusivos, brindando a nuestros niños y niñas todas las condiciones
para desarrollarse seguros de sí mismos, confiando en sus capacidades
y creando vínculos afectivos que motiven su interés por superarse y el
respeto por las personas y el medio ambiente. A partir del desarrollo de
estrategias y metodologías que promuevan el desarrollo de diversos
estilos y tipos de aprendizaje, propiciando la diversidad y a la equidad
como aprendizaje continúo para la vida.`;

// Textos para el modal de Servicios y Beneficios
const serviciosBeneficiosList = [
  "Buzo escolar gratuito por primera vez que se realice matrícula.",
  "Beca de útiles escolares 2026.",
  "Taller de yoga infantil para todos nuestros niveles.",
  "Convenio con Colegio Nuevo Milenio para nuestros egresados de Kínder (matrícula gratis y descuento del 50% de mensualidad).",
  "Agenda de comunicaciones digital \"Notasnet\"."
];

// ==============================================
// Componente de Página: NuestraEscuela
// Descripción: Presenta información detallada sobre la escuela,
//              incluyendo niveles, servicios, misión/visión y equipo.
// ==============================================
const NuestraEscuela = () => {
  // --- Estado para el acordeón de TeamSection ---
  const [expandedDepartment, setExpandedDepartment] = useState(null);
  const [currentPage, setCurrentPage] = useState({});
  
  // --- Estado para el Modal de Misión y Visión ---
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState(null); // Para diferenciar entre modales
  const [modalContent, setModalContent] = useState({}); // Contenido genérico del modal

  // --- Manejador para abrir el Modal de Misión y Visión ---
  const openMisionVisionModal = () => {
    setModalContent({
      title: "Misión y Visión Institucional",
      vision: visionText,
      mission: misionText
    });
    setModalType('misionVision');
    setIsModalOpen(true);
  };

  const openServiciosBeneficiosModal = () => {
    setModalContent({
      title: "Nuestros Servicios y Beneficios",
      items: serviciosBeneficiosList
    });
    setModalType('serviciosBeneficios');
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalType(null);
  };

  // --- Textos para las secciones ---
  const educacionText = `Atendemos a niños con diagnóstico de Trastorno Específico del Lenguaje, previamente diagnosticado por nuestras fonoaudiólogas, mediante una evaluación que se realiza en nuestra misma escuela y en presencia de los padres o acompañantes del menor.\nNuestros rangos educativos son: Nivel Medio Mayor, Prekínder y Kínder.`;
  const serviciosText = `Es importante entregar además de la estimulación del lenguaje y la enseñanza pedagógica, una serie de beneficios que apoyen el día a día de nuestros apoderados y alumnos.`;
  const misionVisionIntroText = `Nuestra misión es guiar a cada estudiante en su desarrollo integral, y nuestra visión es ser reconocidos por formar ciudadanos comprometidos y con pensamiento crítico.`;

  // --- Renderizado del Componente de Página ---
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <main className="flex-1 w-full flex flex-col items-center">
        {/* Sección de Banner Principal */}
        <HeroBanner 
          title="Nuestra Escuela"
          subtitle="Conoce nuestros servicios educativos, instalaciones y beneficios para nuestros estudiantes."
          backgroundImageUrl="/images/gallery/foto3.jpg"
        />
        {/* Sección de Educación y Niveles */}
        <ImageTextSection
          title="Educación y Niveles"
          text={educacionText}
          imageUrl="/images/gallery/foto2.jpg"
          imageAlt="Comunidad educativa reunida en el patio de la Escuela Arcoíris"
          imagePosition="right"
        />
        {/* Sección de Servicios y Beneficios */}
        <ImageTextSection
          title="Servicios y Beneficios"
          text={serviciosText}
          imageUrl="/images/gallery/foto4.jpg"
          imageAlt="Equipo y estudiantes caracterizados en una actividad de la escuela"
          imagePosition="left"
          buttonText="Ver más"
          onButtonClick={openServiciosBeneficiosModal}
        />
        {/* Sección de Misión y Visión (con modal) */}
        <ImageTextSection
          title="Misión y Visión"
          text={misionVisionIntroText}
          imageUrl="/images/gallery/foto5.jpg"
          imageAlt="Educadoras y estudiantes participando en una celebración escolar"
          imagePosition="right"
          buttonText="Conocer Más"
          onButtonClick={openMisionVisionModal}
        />
        {/* Sección de Nuestro Equipo (TeamSection es un componente importado) */}
        <TeamSection
          expandedDepartment={expandedDepartment}
          setExpandedDepartment={setExpandedDepartment}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          className="bg-blue-50"
        />
      </main>
      {/* Renderizar modales condicionalmente según modalType */}
      {isModalOpen && modalType === 'misionVision' && (
        <MisionVisionContentModal 
          content={modalContent} 
          onClose={closeModal} 
        />
      )}
      {isModalOpen && modalType === 'serviciosBeneficios' && (
        <ListContentModal 
          content={modalContent} 
          onClose={closeModal} 
        />
      )}
    </div>
  );
};

export default NuestraEscuela;
